import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  pack: 'MegaPack Familiar Completo',
  quote: 'El Protocolo de las 4 AM me cambió la vida. Después de 6 años de malas noches, por fin sé qué hacer cuando me despierto. Y mi hija duerme sola desde hace 3 semanas.'
}, {
  initials: 'RA',
  name: 'Roberto A.',
  location: 'Buenos Aires',
  pack: 'MegaPack Descanso Profundo Listo',
  quote: 'El Tomo 3 es para enmarcar. Mi hijo tiene TDAH y nunca pudimos instalar una rutina. El Protocolo de Desactivación Sensorial funciona. Punto.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  pack: 'MegaPack Descanso Profundo Listo',
  quote: 'Las rescue cards del Bono 4 están en mi mesa de luz. La noche que mi hijo tuvo un terror nocturno supe exactamente qué hacer. Cero pánico. Protocolo.'
}, {
  initials: 'PM',
  name: 'Pablo M.',
  location: 'Neuquén',
  pack: 'MegaPack Familiar Completo',
  quote: 'Mi adolescente de 14 años leyó el capítulo de cronotipos él solo y me dijo "ahora entiendo por qué no puedo dormirme temprano". Esa conversación sola valió todo.'
}, {
  initials: 'LP',
  name: 'Luciana P.',
  location: 'Rosario',
  pack: 'MegaPack Descanso Profundo Listo',
  quote: 'Los guiones exactos del Bono 3 me salvaron. Ya no improviso a las 2 AM. Sé qué decir y cómo decirlo.'
}];
export function ExtendedTestimonials() {
  return <section className="py-20 bg-charcoal" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="text-center mb-12" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold flex items-center justify-center gap-3 text-white" data-id="element-99">
            ❤️ MÁS FAMILIAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="space-y-6" data-id="element-100">
          {testimonials.map((t, i) => <div key={i} className="bg-night-light rounded-xl p-6 md:p-8 border border-white/10 shadow-sm" data-id="element-101">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-102">
                <div className="flex items-center gap-4 md:w-1/3 shrink-0" data-id="element-103">
                  <div className="w-14 h-14 rounded-full bg-night-lighter text-white flex items-center justify-center font-serif font-bold text-xl" data-id="element-104">
                    {t.initials}
                  </div>
                  <div data-id="element-105">
                    <div className="flex text-gold mb-1" data-id="element-106">
                      {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-107" />)}
                    </div>
                    <p className="font-bold text-white" data-id="element-108">{t.name}</p>
                    <p className="text-sm text-gray-400 flex items-center gap-1" data-id="element-109">
                      📍 {t.location}
                    </p>
                  </div>
                </div>

                <div className="md:w-2/3" data-id="element-110">
                  <div className="inline-block bg-night-lighter px-3 py-1 rounded-md text-sm font-semibold text-gold border border-gold/20 mb-3" data-id="element-111">
                    {t.pack}
                  </div>
                  <p className="text-gray-200 italic text-lg leading-relaxed" data-id="element-112">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}